// extracted by mini-css-extract-plugin
export default {"arrowIcon":"aN2Qv","arrowIconOpened":"bN2Qv"};